import React, { FunctionComponent, useContext } from 'react';
import styles from './styles.module.scss';
import classNames from 'classnames';
import { UserAgentContext } from 'features/user-agent/userAgent';

interface ErrorWrapperProps {
  children?: React.ReactNode;
}

export const ErrorWrapper: FunctionComponent<ErrorWrapperProps> = ({
  children
}) => {
  const { isNativeAppWebview } = useContext(UserAgentContext);

  return (
    <div
      className={classNames(styles['error-page'], {
        [styles['error-page__dark']]: isNativeAppWebview
      })}
    >
      <div className={classNames(styles['error-page__content'])}>
        {children}
      </div>
    </div>
  );
};
